import CryptoJS from 'crypto-js';

const SECRET_KEY = process.env.VUE_APP_CHECKSUM_SECRET_KEY;

export function generateChecksum(data: any) {
  const hash = CryptoJS.HmacSHA256(data, SECRET_KEY).toString(CryptoJS.enc.Hex);
  return hash;
}
